import script from "./PopperButtonEditor.vue?vue&type=script&setup=true&lang=ts"
export * from "./PopperButtonEditor.vue?vue&type=script&setup=true&lang=ts"

import "./PopperButtonEditor.vue?vue&type=style&index=0&id=c14d56f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c14d56f0"]])

export default __exports__